"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullish = void 0;
const isNullish = (value) => value === null || value === undefined;
exports.isNullish = isNullish;
